module.exports = __webpack_public_path__ + "img/Vonix.d71e0d0f.png";